import React, { Component } from 'react';
import ExportReport from '../ExportReport';
import TextMap from '../../../helpers/TextMap';
import miscFunctions from '../../../helpers/misc-functions';
import filterBlueIcon from '../../../assets/images/project-filter-icon-blue.svg';
import searchIcon from '../../../assets/images/search-icon-grey.svg';
import addGroupIcon from '../../../assets/images/add-project-group.png';
import kmzIcon from '../../../assets/images/file-type-doc-icon.svg';
import dataModel from '../../../models/DataModel';
import kmzService from '../../../services/kmzService';
import './ReportHeader.scss';
import Input from '../../../components/Input';

export default class ReportFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDisplayed: false,
      searchString: props.searchString ? props.searchString : '',
    };
    this.textMap = new TextMap();
    this.handleFilterActive = this.handleFilterActive.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.handleDownloadKmz = this.handleDownloadKmz.bind(this);
  }

  componentDidMount() {
    this.setState({ filterDisplayed: this.props.filterDisplayed });
  }

  handleFilterActive() {
    this.setState({ filterDisplayed: !this.state.filterDisplayed });
    if (this.props.handleFilterActive) {
      this.props.handleFilterActive(!this.state.filterDisplayed);
    }
  }

  handleDownloadKmz() {
    const { currentCompany } = this.props;

    if(currentCompany){
      kmzService.generateKmzFile('company', currentCompany.id)
      .then(response=>{
        if(response.error){
          const errorMesssage = response.error.response.data.error;
          dataModel.displayWarnErrorMessage(errorMesssage, 4000, 2);
        }
        else{
          dataModel.displayInfoErrorMessage('Your Company KMZ file generation request has been received. You will be notified when the file is ready to download.', 4000, 1);
        }
      });
    }
  }

  handleSearchInput(e) {
    this.setState({ searchString: e.target.value });
    if (this.props.handleSearchInput) {
      this.props.handleSearchInput(e.target.value);
    }
  }

  render() {
    const { filterDisplayed } = this.state;
    const { reportTitle, reportCount, exportLink, handleLogExport, filterActive, minWidth, handleClosePopup, handleDownloadLocation, changeFileName, displayPopUp, selectedCloseouts, description, filename } = this.props;
    
    const style = minWidth ? { minWidth: minWidth + 'px' } : null;
    
    const resultCount = miscFunctions.convertNumbersToAbbr(reportCount || 0, 2);
    let count=[];
    if (reportCount){
      if(reportCount>0){
        count.push(1);
      }
    }
    if (selectedCloseouts){
      count=selectedCloseouts;
    }
                           
    let placeholderText = this.textMap.searchReport;
    if(reportTitle == 'Project Summary'){
      placeholderText = 'Search Projects';
    }
    else if(reportTitle == 'Project Group Summary'){
      placeholderText = 'Search Groups';
    }
    
    return (
      <div className='ReportHeader' style={style}>
        <div className='report-information'>
          <div className='report-title'>{reportTitle}</div>
          <div className='report-count'>{'(' + resultCount + (resultCount == 1 ? ' result)' : ' results)') }</div>
        </div>
        { this.props.children }
        <div className='report-options'>
          { this.props.addProjectGroup &&
            <div onClick={this.props.addProjectGroup} className='add-project-group-button'>
              <img className="add-project-group-image" src={addGroupIcon} alt="Select"/>
              <label className='add-project-group-label'>New Project Group</label>
            </div>
          }
          { this.props.createNewProject &&
            <div onClick={this.props.createNewProject} className='add-project-group-button'>
              <img className="add-project-group-image" src={addGroupIcon} alt="Select"/>
              <label className='add-project-group-label'>New Project</label>
            </div>
          }
          {!this.props.hideSearch && <div className='report-search'>
            <div className='report-search__inner-container'>
              <img src={searchIcon} alt="Search"/>
              <Input
                className='report-search__input'
                placeholder={placeholderText}
                onChange={this.handleSearchInput}
                value={this.state.searchString}
              />
            </div>
          </div>}
          {!this.props.hideFilterIcon &&
            <div
              className={'report-filter' + (filterDisplayed ? ' report-filter__active' : '')}
              onClick={this.handleFilterActive}
            >
              <img className='filter-icon' src={filterBlueIcon} alt="Filter Report" />
              <p className='filter-text'>{this.textMap.filter.toUpperCase()}</p>
              {
                filterDisplayed && <div className='tab-indicator'></div>
              }
              {filterActive && <div className='filter-pip'></div>}
            </div>
          }
          {!this.props.hideExport &&
            <ExportReport
              exportLink={exportLink}
              logExport={handleLogExport}
              changeFileName={changeFileName}
              handleDownloadLocation={handleDownloadLocation}
              handleClosePopup={handleClosePopup}
              displayPopUp={displayPopUp}
              selectedCloseouts={selectedCloseouts}
              description={description}
              filename={filename}   
              attachmentIds={count}      
               />
          }
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ReportHeader/index.js